module.exports = __webpack_public_path__ + "img/przelewy24.7b392bc.png";